// import React, { useState, useEffect } from "react";
// import { Alert, Col, Container, Row } from "react-bootstrap";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import parse from "html-react-parser";
// import fuziElevatorsApi from "../../../api/fuziElevatorsApi";
// import { ROUTES } from "../../../constants/webRouting";

// const Notification = ({
//   refreshNotification,
//   showNotification,
//   closeNotification,
//   notifications,
//   messageList,
// }) => {
//   const [show, setShow] = useState(showNotification);
//   const [messages, setMessages] = useState(notifications);
//   const location = useLocation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     //console.log("Log Excuted");
//   }, [refreshNotification]);

//   useEffect(() => {
//     //console.log("aa gya1", notifications);
//     let tempMessages = JSON.parse(JSON.stringify(notifications));
//     setMessages(tempMessages);
//   }, []);

//   const markReadNotification = (item) => {
//     //console.log(item)
//     let tempArr = messages.filter((msg) => {
//       if (msg.id === item.id) {
//         msg.status = "Read";
//         // messageList(true,true); 
//       }

//       return true;
//     });

//     //console.log(tempArr)
//     setMessages(tempArr);
//     //setRefreshNotification(new Date());
//     //closeNotification(item);

//     markReadMsg(item.id);
//   };

//   async function markReadMsg(notificationid) {
//     let tasks = await fuziElevatorsApi.markReadMessage(notificationid);
//   }

//   async function openRecord(notification) {
//     if (notification.status === "New")
//       await fuziElevatorsApi.markReadMessage(notification.id);

//     closeNotification();

//     if (notification.parenttype == "lead")
//       navigate(`${ROUTES.LEAD.LIST}/${notification.parentid}`);

//     if (notification.parenttype == "order")
//       navigate(`${ROUTES.ORDER.LIST}/${notification.parentid}`);

//     if (notification.parenttype == "Contact")
//       navigate(`${ROUTES.CONTACT.LIST}/${notification.parentid}`);
    
//     if (notification.parenttype == "warranty")
//       navigate(`${ROUTES.WARRANTY.LIST}/${notification.parentid}`);
//     }

    
    

//   async function deleteNotification(notification) {
//     console.log('notification',notification);
//     let result = await fuziElevatorsApi.deletePushNotification(notification.id);
//     console.log('result',result);
//     let tempArr = messages.filter((msg) => {
//       return msg.id !== notification.id;
//     });
    
//     console.log(tempArr)
//     setMessages(tempArr);
//     messageList(true,false);
//   }

//   return (
//     <div className="notification-area bg-transparent">
//       {messages?.length === 0 && (
//         <Alert variant="success">
//           {" "}
//           <p>No new notifications</p>
//         </Alert>
//       )}
//       {messages?.length > 0 &&
//         messages.map((item) => (
//           <Alert
//             style={{ width: "400px", paddingTop: ".5rem" }}
//             variant="success"
//           >
//             <Alert.Heading>
//               <div className="d-flex align-items-center justify-content-between">
//                 <div
//                   style={{
//                     fontSize: "smaller",
//                     borderBottom: "1px solid #17191c33",
//                     paddingBottom: ".2rem",
//                     marginBottom: ".5rem",
//                   }}
//                 >
//                   <span
//                     className="d-inline"
//                     style={{
//                       border: "none",
//                       color: "#e6e6e6",
//                       fontSize: "1rem",
//                       color: "#645721",
//                     }}
//                   >
//                     {item.createdbyname}
//                   </span>
//                   <span
//                     className="d-inline"
//                     style={{
//                       paddingLeft: "1rem",
//                       color: "#645721",
//                       fontSize: ".8rem",
//                       border: "none",
//                     }}
//                   >
//                     {item.date}
//                   </span>
//                 </div>
//                 <div>
//                   {item.status === "New" && (
//                     <span>
//                       <i
//                         className="fa-regular fa-envelope cursor-pointer mx-3"
//                         onClick={() => markReadNotification(item)}
//                         title="Mark as read"
//                       ></i>
//                     </span>
//                   )}
//                   {item.status === "Read" && (
//                     <span>
//                       <i
//                         className="fa-regular fa-envelope-open mx-3"
//                         title="Already read"
//                       ></i>
//                     </span>
//                   )}
//                   <span>
//                     <i
//                       className="fa-regular fa-trash-can cursor-pointer"
//                       onClick={() => deleteNotification(item)}
//                       title="Delete"
//                     ></i>
//                   </span>
//                 </div>
//               </div>
//             </Alert.Heading>
//             <p  onClick={() => openRecord(item)} style={{cursor:'pointer'}}>
//               {item.status === "New" && (
//                 <div
//                   className="unread cursor-pointer fw-bold"
                 
//                 >
//                   {parse(item.description)}  {item?.message_record_name && `of ${item?.message_record_name}`}
//                 </div>
//               )}
//               {item.status === "Read" && <>{parse(item.description)} {item?.message_record_name && `of ${item?.message_record_name}`}</>}
//             </p>
//             {(item.parenttype === "Lead" || item.parenttype === "Project" || item.parenttype === "Contact" || item.parenttype === "Repair_Ticket") && (
//               <div
//                 className="cursor-pointer unread mt-4"
//                 onClick={() => openRecord(item)}
//               >
//                 {console.log("item", item)}
//                 Open Record{" "}
//                 <i className="fa-solid fa-arrow-up-right-from-square mx-1"></i>
//               </div>
//              )}
//           </Alert>
//         ))}
//     </div>
//   );
// };
// export default Notification;

import React, { useState, useEffect } from "react";
import { Alert } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import parse from "html-react-parser";
import fuziElevatorsApi from "../../../api/fuziElevatorsApi";
import { ROUTES } from "../../../constants/webRouting";

const Notification = ({
  refreshNotification,
  showNotification,
  closeNotification,
  notifications,
  messageList,
  setShowNotification
}) => {
  const [messages, setMessages] = useState(notifications || []);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setMessages([...notifications]);
  }, [notifications]);

  const markReadNotification = (item) => {
    //console.log(item)
    let tempArr = messages.filter((msg) => {
      if (msg.id === item.id) {
        msg.status = "Read";
        // messageList(true,true); 
      }
      return msg;
    });

    //console.log(tempArr)
    setMessages(tempArr);
    //setRefreshNotification(new Date());
    //closeNotification(item);

    markReadMsg(item.id);
  };

  async function markReadMsg(notificationid) {
    await fuziElevatorsApi.markReadMessage(notificationid);
  }

  async function openRecord(notification) {
    if (notification.status === "New")
      await fuziElevatorsApi.markReadMessage(notification.id);

    closeNotification();

    if (notification.parenttype == "lead")
      navigate(`${ROUTES.LEAD.LIST}/${notification.parentid}`);

    if (notification.parenttype == "order")
      navigate(`${ROUTES.ORDER.LIST}/${notification.parentid}`);

    if (notification.parenttype == "Contact")
      navigate(`${ROUTES.CONTACT.LIST}/${notification.parentid}`);
    
    if (notification.parenttype == "warranty")
      navigate(`${ROUTES.WARRANTY.LIST}/${notification.parentid}`);
    }

    
    

  async function deleteNotification(notification) {
    await fuziElevatorsApi.deletePushNotification(notification.id);
    let tempArr = messages.filter((msg) => msg.id !== notification.id);
    setMessages(tempArr);
    messageList(true, false);
  }

  //added by shahir hussain 06-06-2025
  // useEffect(() => {
  // const timer = setTimeout(() => {
  //   if (messages.length > 0) {
  //     // setMessages((prev) => prev.slice(1));//commented by shahir hussain 21-08-2025
  //     setMessages([]);//Added by shahir hussain 21-08-2025 for hide all notification 
  //     setShowNotification(false);
  //   }
  // }, 2500);

//   return () => clearTimeout(timer);
// }, [messages]);

  return (
    <div className="notification-area bg-transparent">
      {messages?.length === 0 && (
        <Alert variant="success">
          <p>No new notifications</p>
        </Alert>
      )}
      {messages?.length > 0 &&
        messages.map((item) => (
          <Alert
            key={item.id}
            style={{ width: "400px", paddingTop: ".5rem" }}
            variant="success"
          >
            <Alert.Heading>
              <div className="d-flex align-items-center justify-content-between">
                <div
                  style={{
                    fontSize: "smaller",
                    borderBottom: "1px solid #17191c33",
                    paddingBottom: ".2rem",
                    marginBottom: ".5rem",
                  }}
                >
                  <span
                    className="d-inline"
                    style={{
                      border: "none",
                      color: "#e6e6e6",
                      fontSize: "1rem",
                      color: "#645721",
                    }}
                  >
                    {item.createdbyname}
                  </span>
                  <span
                    className="d-inline"
                    style={{
                      paddingLeft: "1rem",
                      color: "#645721",
                      fontSize: ".8rem",
                      border: "none",
                    }}
                  >
                    {item.date}
                  </span>
                </div>
                <div>
                  {item.status === "New" && (
                    <span>
                      <i
                        className="fa-regular fa-envelope cursor-pointer mx-3"
                        onClick={() => markReadNotification(item)}
                        title="Mark as read"
                      />
                    </span>
                  )}
                  {item.status === "Read" && (
                    <span>
                      <i
                        className="fa-regular fa-envelope-open mx-3"
                        title="Already read"
                      ></i>
                    </span>
                  )}
                  <span>
                    <i
                      className="fa-regular fa-trash-can cursor-pointer"
                      onClick={() => deleteNotification(item)}
                      title="Delete"
                    />
                  </span>
                </div>
              </div>
            </Alert.Heading>

            <p onClick={() => openRecord(item)} style={{ cursor: "pointer" }}>
              {item.status === "New" ? (
                <div className="unread cursor-pointer fw-bold">
                  {parse(item.description)} {item?.message_record_name && `of ${item?.message_record_name}`}
                </div>
              ) : (
                <>{parse(item.description)} {item?.message_record_name && `of ${item?.message_record_name}`}</>
              )}
            </p>

            {(item.parenttype === "Lead" ||
              item.parenttype === "Project" ||
              item.parenttype === "Contact" ||
              item.parenttype === "Repair_Ticket") && (
              <div className="cursor-pointer unread mt-4" onClick={() => openRecord(item)}>
                Open Record <i className="fa-solid fa-arrow-up-right-from-square mx-1" />
              </div>
             )}
          </Alert>
        ))
        }
    </div>
  );
};
export default Notification;

